import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from "@angular/core";
import {HtmlPipe} from '../../utils/html.pipe';

@Component({
    selector: "woa-receipt",
    templateUrl: "./receipt.component.html",
    styleUrl: "./receipt.component.scss",
    imports: [
        HtmlPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiptComponent {
    public readonly receiptXml: InputSignal<string> = input.required<string>();

    public readonly receipt: Signal<string> = computed(() => this.receiptXml()
        .replace(/<col width='(.*?)'/g, "<column style='--width: $1;'")
        .replace(/<col /g, "<column ")
        .replace(/<col>/g, "<column>")
        .replace(/<\/col>/g, "</column>")
        // render bitmaps (base64-encoded PNG content) as images
        .replace(/<bitmap([^>]*)>([\s\S]*?)<\/bitmap>/g, (_match, attrs, base64) => {
            let style = "";
            const widthPercentMatch = attrs.match(/\swidthPercent=(["'])([^"']*)\1/i);
            if (widthPercentMatch) {
                attrs = attrs.replace(widthPercentMatch[0], "");
                style = ` style="width: ${widthPercentMatch[2]}%; height: auto;"`;
            }
            return `<bitmap><img${attrs}${style} src="data:image/png;base64,${base64.replace(/\s+/g, "")}"/></bitmap>`;
        }));
}
